import { Routes, Route } from "react-router-dom"
import React  from 'react';
import './App.css';
import Loginpage from './components/Loginpage'
import HomePage from "./components/HomePage";
import Register from "./components/Register";
import CartPage from "./components/CartPage";
import ProductDisplay from './components/ProductDisplay'

function App() {
  return (
<div className="App" >
      <Routes>
        <Route path="/" element={ <Loginpage /> } />
        <Route path="/register" element={ <Register /> } /> 
        <Route path="/homepage" element={ <HomePage /> } />



         {/* <Route path="/" element={ <HomePage /> } />  */}
         <Route path="/cartpage" element={ <CartPage /> } /> 
         <Route path="/productdisplay" element={ <ProductDisplay /> } /> 
      </Routes>
    </div>
  );
}

export default App;
